import axios from "axios";

axios.defaults.validateStatus = () => true;

export const apiAbis = axios.create({
  baseURL: process.env.REACT_APP_URL_ABIS,
  headers: {
    usuario: "GTIWSUSER",
    senha: "11TB#idnet%2020",
    key: "Pamela.intranet.sds.pe.gov.br",
  },
});

export function getDadosCriminais(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(
    `wsCriminal/ObterDadosCriminais/${NumeroPessoa}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}

export function getDadosCidadao(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(`wsCriminal/ObterDadosCidadao/${NumeroPessoa}`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
  return response;
}

export function getDadosProcesso(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(
    `wsCriminal/ObterDadosProcesso/${NumeroPessoa}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}

export function getDadosOcorrencia(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(
    `wsCriminal/ObterDadosOcorrencia/${NumeroPessoa}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}

export function getDadosInquerito(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(
    `wsCriminal/ObterDadosInquerito/${NumeroPessoa}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}
export function getDadosInfracao(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(
    `wsCriminal/ObterDadosInfracao/${NumeroPessoa}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}
export function getDadosMandadoPrisao(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(
    `wsCriminal/ObterDadosMandadoPrisao/${NumeroPessoa}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}

export function getDadosCidadaoRC(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(
    `wsCriminal/BuscarCidadaoPorRC/${NumeroPessoa}`,
    {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    }
  );
  return response;
}

export function getFoto3x4(NumeroPessoa: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiAbis.get(`wsCriminal/ObterFoto3x4/${NumeroPessoa}`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });
  return response;
}
